export const FirebaseConfig = {
  apiKey: "AIzaSyCpeWMmGpT2xWi_AsUXVVr-OEeJgAtOIoU",
  authDomain: "exicube-taxi-8c10d.firebaseapp.com",
  databaseURL: "https://exicube-taxi-8c10d-default-rtdb.firebaseio.com",
  projectId: "exicube-taxi-8c10d",
  storageBucket: "exicube-taxi-8c10d.appspot.com",
  messagingSenderId: "487122222788",
  appId: "1:487122222788:web:23030ea8db036a3eb0d391",
  measurementId: "G-YNQBP54ZL6",
};
